// Module
var code = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"3\" height=\"15\" viewBox=\"0 0 3 15\"> <g fill=\"#AAA99F\" fill-rule=\"evenodd\"> <circle cx=\"1.5\" cy=\"1.5\" r=\"1.5\"/> <circle cx=\"1.5\" cy=\"7.5\" r=\"1.5\"/> <circle cx=\"1.5\" cy=\"13.5\" r=\"1.5\"/> </g> </svg> ";
// Exports
module.exports = code;